import { get } from 'lodash';
import { createSelector } from 'reselect';

import { makeOptionsData } from 'Common/FormHelper';
import { getSites } from 'State/selectors';
import { createMap } from 'Common/Helpers/format';

import * as ImportSettingHelpers from '../ImportSettingsHelper';

const root = state => get(state, 'ImportStudentState');

export const getLanguages = state =>
  get(state, 'ImportStudentState.languages.Data', []);

export const getGrades = state => get(state, 'ImportStudentState.grades', []);

export const getActiveSites = createSelector(getSites, sites =>
  sites.filter(s => s.IsActive && s.IsLicensed)
);

export const getStoredMealMappingData = state =>
  get(root(state), 'storedMealMappingData');

export const getStoredLanguageMappingData = state =>
  get(root(state), 'storedLanguageMappingData');

// sites
export const getSiteOptions = createSelector(getActiveSites, sites =>
  makeOptionsData(sites, {
    keyKey: 'Id',
    valueKey: 'Id',
    textKeys: ['Id', 'Description'],
  })
);
export const getSitesMappedDescriptions = createSelector(
  getActiveSites,
  sites => createMap(sites, 'Id', 'Description')
);
export const getSitesMapped = state => {
  const siteDescriptions = getSitesMappedDescriptions(state);
  const siteMappingData = get(
    state,
    'ImportStudentState.newSiteMappingData',
    []
  );
  siteMappingData.map(s => {
    s.mappedValue = siteDescriptions[s.InternalField];
    return s;
  });
  return siteMappingData;
};

// grade
export const getGradeOptions = createSelector(getGrades, grades =>
  makeOptionsData(grades, {
    keyKey: 'Id',
    valueKey: 'Id',
    textKeys: ['Id', 'Description'],
  })
);
export const getGradesMappedDescriptions = createSelector(getGrades, grades =>
  createMap(grades, 'Id', 'Description')
);
export const getGradesMapped = state => {
  const gradeDescriptions = getGradesMappedDescriptions(state);
  const gradeMappingData = get(
    state,
    'ImportStudentState.gradeMappingData',
    []
  );
  gradeMappingData.map(x => {
    x.mappedValue = gradeDescriptions[x.InternalField];
    return x;
  });
  return gradeMappingData;
};

export const getFormattedLanguageData = createSelector(
  getLanguages,
  getStoredLanguageMappingData,
  (languages, languageData) => {
    const formattedLanguageData = ImportSettingHelpers.formatLanguageData(
      languageData,
      languages
    );

    return formattedLanguageData;
  }
);

export const getLanguageOptions = state => {
  const formattedLanguageData = getFormattedLanguageData(state);
  const [languageOptions] = formattedLanguageData;

  return languageOptions;
};

export const getMappedLanguageData = state => {
  const formattedLanguageData = getFormattedLanguageData(state);
  const [, languageDataMapped] = formattedLanguageData;
  return languageDataMapped;
};

export const getMappedLanguageList = state => {
  const formattedLanguageData = getFormattedLanguageData(state);

  const [, , mappedLanguageList] = formattedLanguageData;
  return mappedLanguageList;
};



// WEBPACK FOOTER //
// ./src/pages/importstudents/state/selectors.js